import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Text/password input with a show/hide (eye) toggle.
// Forwards all standard input props; keep passing data-testid + className as before.
export function PasswordInput({ className = "", testid, wrapperClassName = "", ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${wrapperClassName}`}>
      <input
        {...props}
        data-testid={testid}
        type={show ? "text" : "password"}
        className={`${className} pr-10`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        aria-label={show ? "Hide password" : "Show password"}
        title={show ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-muted2 hover:text-ink"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
